import React, { ChangeEvent, useState } from 'react'
import TextFieldMui from '@mui/material/TextField'
import { VisibilityOutlined, Visibility }  from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material'
import { useStore } from '../../contexts/store'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next';
import PrettyMarkdownInput from '../PrettyMarkdownInput/PrettyMarkdownInput'
import muiTheme from '../../muiTheme'
import { MdFormat } from '../PrettyMarkdownInput/types'
import PrettyMarkdownBox from '../PrettyMarkdownInput/PrettyMarkdownBox'

//
type SlotProps = {
  markdown?: {
    style?: object,
  },
  textfield?: {
    style?: object,
  }
}

const MarkdownEnabledTextfield = ({
    handleInputChange,
    handleClose,
    placeholder="",
    minRows,
    submit=()=>{},
    value,
    disabled=false,
    style={},
    whitelist,
    helperText,
    slotProps={}
  }: {
    handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void,
    handleClose: () => void,
    placeholder?: string,
    minRows: number,
    submit?: () => void,
    value: string,
    disabled?:boolean,
    style?:object,
    whitelist:MdFormat[],
    helperText:string,
    slotProps?:SlotProps,
  }) => {
    const { uiStore } = useStore()
    const { t } = useTranslation()
    const [ showHelper, setShowHelper] = useState(false)

    const input = (uiStore.useRichTextInput) ?
      <PrettyMarkdownInput
        value={value}
        onChange={(value:string) => { handleInputChange({target: {value}} as ChangeEvent<HTMLInputElement>) }}
        whitelist={whitelist}
        style={{
          border:'2px solid #888', //+ muiTheme.palette.primary.main,
          borderRadius:'5px',
          padding:'10px',
          paddingTop:'25px',
          paddingBottom:'5px',
          height:'100%',
          ...slotProps?.markdown?.style
        }}
      />
    :
      <TextFieldMui
        autoFocus
        id="comment-message-input-edit"
        fullWidth
        label={placeholder}
        minRows={minRows}
        maxRows={8}
        multiline
        onChange={handleInputChange}
        disabled={disabled}
        slotProps={{
          htmlInput: {
            sx: { fontSize: '16px' }
          },
          inputLabel: {
            sx: { fontSize: '16px'}
          },
        }}
        style={{...slotProps?.textfield?.style}}
        value={value}
      />

  const css = {
    position:'relative',
    overflow:'hidden',
    paddingTop:'5px',
    paddingBottom:'15px',
    '.label': {
      position:'absolute',
      paddingLeft:'3px',
      paddingRight:'3px',
      color:'#444',
      backgroundColor:'#fff',
      left:11,
      top:-5,
      fontSize:'13px'
    },
    ...style
  }

  const useMarkdownA = t('You may use Markdown.').split('Markdown')
  const useMarkdown = <>{useMarkdownA[0]} <span style={{textDecoration:'underline'}}>{'Markdown'}</span> {useMarkdownA[1]}</>

  return <Box sx={css} onKeyDown={(ev) => {
          if (ev.key === 'Enter' && ev.ctrlKey) {
            submit()
            ev.preventDefault()
          }
          if (ev.key === 'Escape') {
            handleClose()
            ev.stopPropagation()
            ev.preventDefault()
          }
        }}>
    {input}
    <Box
      title={'' + (!uiStore.useRichTextInput ? t('Switch to the Rich Text Editor to see your Markdown right away') : t('Switch to the normal editor. You can still use markdown.')) }
      onClick={()=>{ uiStore.setUseRichTextInput(!uiStore.useRichTextInput) }}
      sx={{
        position:'absolute',
        right:'1px',
        top:'5px',
        px:'2px',
        height:'26px',
        opacity: uiStore.useRichTextInput ? 0.8 : 0.5,
        ':hover': {
          opacity:1,
          cursor:'pointer'
        }
      }}
      >
        { uiStore.useRichTextInput ? <Visibility style={{color:'darkgreen'}} /> : <VisibilityOutlined /> }
    </Box>
    {uiStore.useRichTextInput && <Box className="label">{placeholder}</Box>}
    <Box title={t('You may use Markdown.') + ' ' + helperText} sx={{color:'#444', fontSize:12, whiteSpace:'nowrap', overflow:'hidden'}}><span style={{userSelect:'none', cursor:'pointer'}} onClick={() => { setShowHelper(!showHelper)}}>{useMarkdown} </span> {helperText}</Box>
      <Dialog onClose={() => { setShowHelper(false)}} open={showHelper}>
        <DialogTitle>{t('Markdown')}</DialogTitle>
        <DialogContent>
          {t('You may add formatting to your text using the following markups:')}
          <ul>
          {whitelist.map(s => <li key={s}>
            <PrettyMarkdownBox value={t(`explain_md_for_${s}`)} />
          </li>)}
          </ul>
          <DialogActions>
            <Button variant='contained' onClick={() => { setShowHelper(false)}}>{t('Ok')}</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
  </Box>
}

export default observer(MarkdownEnabledTextfield)